/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserDelegationResponse {
    getFixupPrototypeFunction() { return UserDelegationResponse.fixupPrototype; }

    static newInstance(model: Partial<UserDelegationResponse>): UserDelegationResponse {
        let obj = Object.assign(new UserDelegationResponse(), model);
        UserDelegationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserDelegationResponse>): UserDelegationResponse {
        if (!model) return null;
        return UserDelegationResponse.newInstance(<UserDelegationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserDelegationResponse) {
        if (!obj) return;

        models.UserDelegationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserDelegationResponse): boolean {
        Object.setPrototypeOf(obj, UserDelegationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User delegation id
     */
    id: string;

}
